/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqBrandModelResponseMonitoringWebsitePiracyWebsiteContentsDetailPiracyResponse,
  MarqCommonProtocolFileResponse,
  MonitoringFilterProtocolResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsCancelConfirmRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsExportCsvRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetChannelGroupCountResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetDetailRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetStatusCountResponse,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostConfirmRequest,
  MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostDismissRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class WebsiteContentsPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyChannelGroupCountList
   * @request GET:/website/contents/piracy/channel_group_count
   */
  contentsPiracyChannelGroupCountList = (params: RequestParams = {}) =>
    this.http.request<MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetChannelGroupCountResponse, any>({
      path: `/website/contents/piracy/channel_group_count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyFilterPlatformList
   * @request GET:/website/contents/piracy/filter/platform
   */
  contentsPiracyFilterPlatformList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/piracy/filter/platform`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyStatusCountList
   * @request GET:/website/contents/piracy/status_count
   */
  contentsPiracyStatusCountList = (params: RequestParams = {}) =>
    this.http.request<MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetStatusCountResponse, any>({
      path: `/website/contents/piracy/status_count`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyListingCountCreate
   * @request POST:/website/contents/piracy/listing_count
   */
  contentsPiracyListingCountCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingCountResponse, any>({
      path: `/website/contents/piracy/listing_count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyFilterWebsiteCreate
   * @request POST:/website/contents/piracy/filter/website
   */
  contentsPiracyFilterWebsiteCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetWebsiteFilterRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/piracy/filter/website`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyFilterAssetList
   * @request GET:/website/contents/piracy/filter/asset
   */
  contentsPiracyFilterAssetList = (params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/website/contents/piracy/filter/asset`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyExportCsvCreate
   * @request POST:/website/contents/piracy/export_csv
   */
  contentsPiracyExportCsvCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsExportCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/website/contents/piracy/export_csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyListCreate
   * @request POST:/website/contents/piracy/list
   */
  contentsPiracyListCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListResponse, any>({
      path: `/website/contents/piracy/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyListingIdListCreate
   * @request POST:/website/contents/piracy/listing-id-list
   */
  contentsPiracyListingIdListCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetListingIdListResponse, any>({
      path: `/website/contents/piracy/listing-id-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyDetailCreate
   * @request POST:/website/contents/piracy/detail
   */
  contentsPiracyDetailCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsGetDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqBrandModelResponseMonitoringWebsitePiracyWebsiteContentsDetailPiracyResponse, any>({
      path: `/website/contents/piracy/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyConfirmCreate
   * @request POST:/website/contents/piracy/confirm
   */
  contentsPiracyConfirmCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/website/contents/piracy/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyDismissCreate
   * @request POST:/website/contents/piracy/dismiss
   */
  contentsPiracyDismissCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsPostDismissRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/website/contents/piracy/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags WebsiteContentsPiracy
   * @name ContentsPiracyCancelConfirmCreate
   * @request POST:/website/contents/piracy/cancel-confirm
   */
  contentsPiracyCancelConfirmCreate = (
    data: MonitoringWebsiteContentPiracyWebsiteContentsPiracyProtocolsCancelConfirmRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/website/contents/piracy/cancel-confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
